module Meevo.Plugins.PosHardware {
  "use strict";

  /**
  * Main Section of PosHardware 
  */
  export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {

  }
}